import * as types from './types';
import { loading, success, handleErrorException } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

export const getRouteSchedule = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GET_TRUCK_ROUTE_SCHEDULE_LIST_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `TruckRoute/GetTruckRouteSchedules`
      );
      dispatch(
        success(types.GET_TRUCK_ROUTE_SCHEDULE_LIST, response.data.Data)
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching truck route schedule list. Please try again',
      };
      dispatch(
        handleErrorException(
          ex,
          types.GET_TRUCK_ROUTE_SCHEDULE_LIST_LOADING_ERROR,
          defaultError
        )
      );
    }
    dispatch(loading(types.GET_TRUCK_ROUTE_SCHEDULE_LIST_LOADING, false));
  };
};

export const deleteTruckRouteSchedule = id => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.DELETE_TRUCK_ROUTE_SCHEDULE_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `TruckRoute/DeleteTruckRouteSchedule/${id}`
      );
      dispatch(success(types.DELETE_TRUCK_ROUTE_SCHEDULE, response.data));
      dispatch(getRouteSchedule());
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while deleting truck route schedule. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.DELETE_TRUCK_ROUTE_SCHEDULE_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.DELETE_TRUCK_ROUTE_SCHEDULE_LOADING, false));
    }
  };
};

export const clearTruckRouteErrors = () => {
  return {
    type: types.CLEAR_TRUCK_ROUTE_SCHEDULE_LIST_ERROR,
  };
};

export const clearDeleteTruckRouteScheduleSuccess = () => {
  return {
    type: types.CLEAR_DELETE_TRUCK_ROUTE_SCHEDULE_SUCCESS,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/managetruckrouteschedulelist/actions.js